module.exports = __webpack_public_path__ + "static/img/bg.59d2bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/bg.png
// module id = yM6R
// module chunks = 44